import { useCallback, useState } from 'react';

import { Undo2 } from 'lucide-react';
import { Button, DefaultPopover, DefaultTooltip } from 'twyne-new.ui';

import { useAppAlert } from '@/components/AppAlert';
import { useGrid } from '@/components/Grid/context';

import { useBucketStore } from '../../../store';
import actionsConfig from '../actionsConfig';

export default function resetAction(info) {
  return <ResetAction info={info} />
}

function ResetAction({ info }) {
  const { item: { reset: action } } = actionsConfig
  const { id, subidKey: subid, status } = info.row.original
  const disabled = status === 'disabled'
  const { reset } = useBucketStore()
  const { handleRefresh } = useGrid()
  const { handleSuccess, handleError } = useAppAlert()
  const [open, setOpen] = useState(false)

  const handleSubmit = useCallback(async () => {
    try {
      const ok = await reset({ id, subid })
      if (!ok) throw new Error()
      await handleRefresh()
      handleSuccess('Success', 'Bucket reset.')
      setOpen(false)
    } catch {
      handleError('Error', 'The bucket was not reset.')
    }
  }, [reset, id, subid, handleRefresh, handleSuccess, handleError])

  if (disabled) {
    return <div className='opacity-40'>
      <Undo2 size={16} />
    </div>
  }

  return <DefaultPopover
    title={action.title}
    trigger={<DefaultTooltip content={action.tip} triggerProps={{ asChild: true }}>
      <Undo2 size={16} />
    </DefaultTooltip>}
    wrapperProps={{ open, onOpenChange: setOpen }}
  >
    <div className='flex flex-col gap-2'>
      <span>{action.content}</span>
      <Button block color='danger' onClick={handleSubmit}>
        Yes
      </Button>
    </div>
  </DefaultPopover>
}
